
import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "application/features/clientAuth/authClientSlice";
import { useLoginClientMutation, useRegisterClientMutation } from "application/features/clientAuth/authClientApiSlice";
import InputPsw from "shared/InputPsw/InputPsw";
import { useTranslation } from "react-i18next";

export interface LoginClientProps {
  className?: string;
  onLogin?: () => void;
}

const LoginClient: FC<LoginClientProps> = ({ className = "", onLogin }) => {

  const { t, ready } = useTranslation("translation");

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');

  const [loginClient, { isLoading: isLoginClientLoading }] = useLoginClientMutation();
  const [registerClient, { isLoading: isRegisterLoading }] = useRegisterClientMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOtp, setShowOtp] = useState(false);


  const handleLogin = async (e: any) => {
    e.preventDefault();
    try {
      const loginReponse = await loginClient({ email, password, otp_code: otp }).unwrap()
      dispatch(setCredentials({ ...loginReponse }))
      if (!loginReponse.error) {
        localStorage.setItem('client_token', loginReponse.token)
        if (onLogin) {
          onLogin()
        } else {
          navigate("/client/")
        }
      }
    } catch (error: any) {
      if (!error?.data) {
        setError("Nessuna connessione al server")
      } else {
        setError("Email o password sbagliata")
      }
    }
  }

  if (!ready) return null;

  return (
    <div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
      <Helmet>
        <title>{t("translation:userLogin.title")} | TRIBYOU</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <div className="max-w-md mx-auto space-y-6 ">
          {/* FORM */}

          {!showOtp ?

            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                {t("translation:userLogin.heading")}
              </h2>
              <form className="grid grid-cols-1 gap-6" onSubmit={handleLogin} method="post">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                  {t("translation:userLogin.form.email")}
                  </span>
                  <Input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="address@example.com"
                    className="mt-1"
                  />
                </label>
                <label className="block">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                  {t("translation:userLogin.form.password")}
                  </span>
                  <InputPsw
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    className="mt-1"
                  />
                </label>
                <span className="block text-left text-neutral-700 dark:text-neutral-300 cursor-pointer hover:text-primary-6000">
                  <Link to="/reset-password-client">{t("translation:userLogin.form.forgotPassword")}</Link>
                </span>
                {error && <span className="text-red-500">{error}</span>}
                <ButtonPrimary type="submit" loading={isLoginClientLoading}>{t("translation:userLogin.form.loginButton")}</ButtonPrimary>
              </form>

              {/* ==== */}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                <Link to="/signup-client">{t("translation:userLogin.form.createAccount")}</Link>
              </span>
            </>
            :
            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              {t("translation:userLogin.otpSection.heading")}
              </h2>
              <p className="mt-2 text-neutral-800">
                {t("translation:userLogin.otpSection.description")}
                <span className="font-semibold"> {email}</span>
              </p>
              <form className="grid grid-cols-1 gap-6" onSubmit={handleLogin} method="post">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                  {t("translation:userLogin.otpSection.codeLabel")}
                  </span>
                  <Input
                    onChange={(e) => setOtp(e.target.value)}
                    type="text"
                    placeholder="123456"
                    className="mt-1"
                  />
                </label>
                {error && <span className="text-red-500">{error}</span>}
                <ButtonPrimary type="submit" loading={isLoginClientLoading}>{t("translation:userLogin.otpSection.sendCodeButton")}</ButtonPrimary>
              </form>

              {/* ==== TODO: Missing href to resend the code */}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                {t("translation:userLogin.otpSection.resendMessage")}{` `}<Link className="text-red-500" to="#">{t("translation:userLogin.otpSection.resendButton")}</Link>
              </span>
            </>
          }

        </div>
      </div>
    </div>
  );
};

export default LoginClient;
